/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListaInstytucji } from '../../models/lista-instytucji';

export interface ApiWebInstytucjeGet$Json$Params {
  'X-User-NIPy'?: string;
}

export function apiWebInstytucjeGet$Json(http: HttpClient, rootUrl: string, params?: ApiWebInstytucjeGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ListaInstytucji>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeGet$Json.PATH, 'get');
  if (params) {
    rb.header('X-User-NIPy', params['X-User-NIPy'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ListaInstytucji>;
    })
  );
}

apiWebInstytucjeGet$Json.PATH = '/api/web/instytucje';
